import ButtonWithLoader from '../ButtonWithLoader/ButtonWithLoader';

type ButtonSubmitDataProps = {
  isEdit?: boolean;
  disabled?: boolean;
  isSubmitting?: boolean;
}
function ButtonSubmitData({
  isEdit = false,
  disabled,
  isSubmitting = false,
}: ButtonSubmitDataProps) {
  return (
    <ButtonWithLoader
      type="submit"
      variant="contained"
      color="secondary"
      label={isEdit ? 'Save' : 'Submit'}
      isLoading={isSubmitting}
      disabled={disabled}
    />
  );
}

export default ButtonSubmitData;
